var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserRoundCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66406 17.5C1.66399 16.2169 2.03417 14.9611 2.73018 13.8832C3.42619 12.8053 4.41846 11.9512 5.5879 11.4233C6.75733 10.8954 8.05426 10.7162 9.32303 10.9072C10.5918 11.0982 11.7785 11.6512 12.7407 12.5M13.3307 15.8333L14.9974 17.5L18.3307 14.1667M12.4974 6.66667C12.4974 8.96785 10.6319 10.8333 8.33073 10.8333C6.02954 10.8333 4.16406 8.96785 4.16406 6.66667C4.16406 4.36548 6.02954 2.5 8.33073 2.5C10.6319 2.5 12.4974 4.36548 12.4974 6.66667Z",
    stroke: "#EA580C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserRoundCheck);
export default __webpack_public_path__ + "static/media/UserRoundCheck.83cc039f2af30b7223ccfd1b2b519bf5.svg";
export { ForwardRef as ReactComponent };